import { Router } from 'found'
import { TFunction } from 'i18next'
import React, { Fragment } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { fetchTimetable } from '../../actions/api'
import { checkInModal, openModal } from '../../actions/timetable'
import Download from '../../icons/Download'
import { allowTimetableFetchSelector } from '../../lib/roleUtils'
import { isMobileSelector, shiftTasksToTimetableParams } from '../../Selectors'
import { Action, AppState, Dispatch, Shift } from '../../types'
import { TimetableParams } from '../../types/Input'
import { TimetableModal, TimetableRequestOrigin } from '../../types/States'
import LoadingIndicator from '../LoadingIndicator'
import TaskButton from '../task/TaskButton'
import UsedForDrivingModal from './UsedForDrivingModal'

type Props = {
  router?: Router
  fetchTimetable: (
    isUsedForDriving: boolean,
    parts: Array<TimetableParams>,
    requestOrigin: TimetableRequestOrigin
  ) => void
  requestOrigin: TimetableRequestOrigin
  isCommuter?: boolean
  isMobile: boolean
  timetableParams: Array<TimetableParams>
  loading?: boolean
  modal: TimetableModal
  openModal: (
    isOpen: boolean,
    usedTimetableParams: Array<TimetableParams>,
    pendingRequestOrigin: TimetableRequestOrigin | null
  ) => void
  checkInModal: (checked: boolean) => void
  allowTimetableFetch: boolean
}

const TimetableButton = ({
  timetableParams,
  fetchTimetable,
  isCommuter,
  loading,
  modal,
  openModal,
  checkInModal,
  isMobile,
  allowTimetableFetch,
  requestOrigin,
}: Props) => {
  if (!timetableParams || timetableParams.length === 0) {
    return null
  }

  return (
    <Fragment>
      <UsedForDrivingModal
        modal={modal}
        fetchTimetable={fetchTimetable}
        openModal={openModal}
        timetableParams={timetableParams}
        checkInModal={checkInModal}
        isMobile={isMobile}
      />
      {allowTimetableFetch && (
        <TaskButton
          disabled={loading}
          isCommuter={isCommuter}
          onClick={() => openModal(true, timetableParams, requestOrigin)}
        >
          {loading ? (
            <LoadingIndicator size="small" padded={false} />
          ) : (
            <Download iconSize="smallest" />
          )}
        </TaskButton>
      )}
    </Fragment>
  )
}

type PropsIn = {
  t: TFunction
  shift?: Shift
  timetableParams: TimetableParams
  requestOrigin: TimetableRequestOrigin
}

const mapStateToProps = (state: AppState, { shift, timetableParams }: PropsIn) => {
  const isMobile = isMobileSelector(state)

  const params = shift
    ? shiftTasksToTimetableParams(shift)
    : timetableParams
    ? [timetableParams]
    : []
  const paramsFromState = state.timetable.usedTimetableParams

  return {
    isMobile,
    timetableParams: paramsFromState && paramsFromState.length > 0 ? paramsFromState : params,
    loading: state.timetable.loading,
    modal: state.timetable.modal,
    allowTimetableFetch: allowTimetableFetchSelector(state),
  }
}
const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchTimetable: (
    isUsedForDriving: boolean,
    parts: TimetableParams[],
    requestOrigin: TimetableRequestOrigin
  ) => dispatch(fetchTimetable(isUsedForDriving, parts, requestOrigin) as unknown as Action),
  openModal: (
    isOpen: boolean,
    usedTimetableParams: TimetableParams[],
    pendingRequestOrigin: TimetableRequestOrigin | null
  ) => dispatch(openModal({ isOpen, usedTimetableParams, pendingRequestOrigin })),
  checkInModal: (checked: boolean) => dispatch(checkInModal(checked)),
})

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TimetableButton))
